import { useInfiniteQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	enabled?: boolean;
}

const getNextPageParam = ({ next }: CMSPaginatedData<Store>) => {
	return next;
};

export const fetchStoreByName = async (name?: string, nextPageUrl?: string) => {
	const url =
		nextPageUrl ||
		`/store/store/?search=${encodeURIComponent(name ?? "")}&page=1`;

	const { data } = await cmsClient.get<CMSPaginatedData<Store>>(url);

	return data;
};

const useStore = (name?: string, options: Options = { enabled: true }) => {
	const query = useInfiniteQuery(
		["user", name],
		({ pageParam }) => fetchStoreByName(name, pageParam),
		{
			getNextPageParam,
			enabled: options.enabled
		}
	);

	return query;
};

export default useStore;
